//# sourceMappingURL=config.mjs.map
/// <reference types="./config.d.mts" />
import * as $ai_config from "../../../../data_types/data/ai_config.mjs";
import * as $remote from "../../../../data_types/data/remote.mjs";
import * as $weaviate from "../../../../data_types/data/weaviate.mjs";
import * as $colors from "../../../../ds/ds/colors.mjs";
import * as $button from "../../../../ds/ds/components/button.mjs";
import * as $dropdown from "../../../../ds/ds/components/dropdown.mjs";
import * as $input from "../../../../ds/ds/components/input.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $skeleton from "../../../../ds/ds/components/skeleton.mjs";
import * as $toggler from "../../../../ds/ds/components/toggler.mjs";
import * as $typography from "../../../../ds/ds/components/typography.mjs";
import * as $icons from "../../../../ds/ds/icons.mjs";
import * as $float from "../../../../gleam_stdlib/gleam/float.mjs";
import * as $int from "../../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../../../gleam_stdlib/gleam/pair.mjs";
import * as $string from "../../../../gleam_stdlib/gleam/string.mjs";
import * as $redraw from "../../../../redraw/redraw.mjs";
import * as $compose from "../../../../redraw_batteries/redraw/batteries/compose.mjs";
import * as $a from "../../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $e from "../../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../../redraw_dom/redraw/dom/html.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $length from "../../../../sketch/sketch/css/length.mjs";
import * as $assoc from "../../../../tiamat/gleam/assoc.mjs";
import * as $list_ from "../../../../tiamat/gleam/list_.mjs";
import * as $function from "../../../../tiamat/tiamat/function.mjs";
import * as $ai_config_effects from "../../../admin/effects/ai_config.mjs";
import * as $card from "../../../components/card.mjs";
import * as $store from "../../../data/store.mjs";
import { toList, isEqual } from "../../../gleam.mjs";
import * as $common from "../../../view/common.mjs";
import * as $org_common from "../../../view/organization/common.mjs";

function use_store_config(store_config) {
  return $function.tap(
    $redraw.use_state(new $remote.NotLoaded()),
    (_use0) => {
      let set_ai_config = _use0[1];
      let _block;
      let _pipe = $remote.map(store_config, (c) => { return c.org_id; });
      _block = $remote.unwrap(_pipe, "");
      let org_id = _block;
      return ((_capture) => { return $redraw.use_effect(_capture, [org_id]); })(
        () => { return set_ai_config(store_config); },
      );
    },
  );
}

function pii_vocabulary() {
  return $redraw.component_(
    "PiiVocabulary",
    (_use0) => {
      let ai_config = _use0[0];
      let set_ai_config = _use0[1];
      if (ai_config instanceof $remote.NotLoaded) {
        return $skeleton.skeleton(100, 100);
      } else if (ai_config instanceof $remote.Loading) {
        return $skeleton.skeleton(100, 100);
      } else if (ai_config instanceof $remote.Errored) {
        return $skeleton.skeleton(100, 100);
      } else {
        let ai_config$1 = ai_config[0];
        let pii_vocabulary$1 = ai_config$1.config.pii_vocabulary;
        let vocabs = $list.index_map(
          pii_vocabulary$1,
          (v, i) => { return [i, v]; },
        );
        let border = $l.styles(
          toList([
            $css.border("1px solid " + $colors.palette.grey_200),
            $css.border_radius($length.px(9)),
          ]),
        );
        let on_remove = (index) => {
          return $e.on_click(
            (_) => {
              let _pipe = vocabs;
              let _pipe$1 = $assoc.remove(_pipe, index);
              let _pipe$2 = $list.map(_pipe$1, $pair.second);
              let _pipe$3 = ((_capture) => {
                return $ai_config.set_pii_vocabulary_in_ai_config(
                  ai_config$1,
                  _capture,
                );
              })(_pipe$2);
              let _pipe$4 = new $remote.Loaded(_pipe$3);
              return set_ai_config(_pipe$4);
            },
          );
        };
        let on_edit = (index, name) => {
          let _pipe = vocabs;
          let _pipe$1 = $assoc.set(_pipe, index, name);
          let _pipe$2 = $list.map(_pipe$1, $pair.second);
          let _pipe$3 = ((_capture) => {
            return $ai_config.set_pii_vocabulary_in_ai_config(
              ai_config$1,
              _capture,
            );
          })(_pipe$2);
          let _pipe$4 = new $remote.Loaded(_pipe$3);
          return set_ai_config(_pipe$4);
        };
        let on_add = $e.on_click(
          (_) => {
            let _pipe = ai_config$1.config.pii_vocabulary;
            let _pipe$1 = $list_.push(_pipe, "");
            let _pipe$2 = ((_capture) => {
              return $ai_config.set_pii_vocabulary_in_ai_config(
                ai_config$1,
                _capture,
              );
            })(_pipe$1);
            let _pipe$3 = new $remote.Loaded(_pipe$2);
            return set_ai_config(_pipe$3);
          },
        );
        return $l.column(
          toList([$l.gap(12)]),
          toList([]),
          toList([
            $common.underlined_title(
              toList([]),
              toList([$h.text("PII Vocabulary")]),
            ),
            $l.column(
              toList([$l.gap(6), $l.align("start")]),
              toList([]),
              toList([
                $redraw.keyed(
                  (_capture) => {
                    return $l.row(toList([$l.gap(4)]), toList([]), _capture);
                  },
                  $list.map(
                    vocabs,
                    (_use0) => {
                      let index = _use0[0];
                      let element = _use0[1];
                      let _pipe = $l.row(
                        toList([
                          $l.align("center"),
                          $l.gap(6),
                          $l.padding(6),
                          border,
                        ]),
                        toList([]),
                        toList([
                          $input.input(
                            (() => {
                              let _pipe = $input.value(element);
                              return $input.on_input(
                                _pipe,
                                (_capture) => {
                                  return on_edit(index, _capture);
                                },
                              );
                            })(),
                          ),
                          $h.div(
                            toList([on_remove(index)]),
                            toList([$icons.small($icons.cross())]),
                          ),
                        ]),
                      );
                      return ((_capture) => {
                        return $pair.new$($int.to_string(index), _capture);
                      })(_pipe);
                    },
                  ),
                ),
                $button.secondary(
                  toList([on_add]),
                  toList([
                    $h.text("Add new vocabulary"),
                    $icons.small($icons.add()),
                  ]),
                ),
              ]),
            ),
          ]),
        );
      }
    },
  );
}

function sorted_model_choices() {
  let _pipe = $list.sort(
    $ai_config.all_models,
    (a, b) => {
      return $string.compare(
        $ai_config.model_to_string(a),
        $ai_config.model_to_string(b),
      );
    },
  );
  return $list.map(
    _pipe,
    (model) => {
      return $dropdown.choice($ai_config.model_to_string(model), model);
    },
  );
}

function model_selection_dropdown(
  config,
  set_ai_config,
  model_dropdown,
  selected,
  setter
) {
  let _pipe = $dropdown.on_selected_(
    (model) => {
      let _pipe = config;
      let _pipe$1 = setter(_pipe, model);
      let _pipe$2 = new $remote.Loaded(_pipe$1);
      return set_ai_config(_pipe$2);
    },
  );
  let _pipe$1 = $dropdown.placeholder(_pipe, "Select model...");
  let _pipe$2 = $dropdown.selected(_pipe$1, new Some(selected));
  let _pipe$3 = $dropdown.show_arrow(_pipe$2, true);
  let _pipe$4 = $dropdown.searchable(_pipe$3, true);
  return model_dropdown(_pipe$4, sorted_model_choices());
}

function choice_of_models() {
  return $compose.children(
    $dropdown.dropdown(),
    (default_model_dropdown) => {
      return $compose.children(
        $dropdown.dropdown(),
        (rag_model_dropdown) => {
          return $compose.children(
            $dropdown.dropdown(),
            (search_model_dropdown) => {
              return $compose.children(
                $dropdown.dropdown(),
                (translate_model_dropdown) => {
                  return $compose.children(
                    $dropdown.dropdown(),
                    (conversational_model_dropdown) => {
                      return $compose.children(
                        $dropdown.dropdown(),
                        (website_scrapping_model_dropdown) => {
                          return $compose.children(
                            $dropdown.dropdown(),
                            (rows_columns_model_dropdown) => {
                              return $compose.children(
                                $dropdown.dropdown(),
                                (advanced_cell_model_dropdown) => {
                                  return $compose.children(
                                    $dropdown.dropdown(),
                                    (docx_question_model_dropdown) => {
                                      return $compose.children(
                                        $dropdown.dropdown(),
                                        (website_capture_model_dropdown) => {
                                          return $compose.children(
                                            $dropdown.dropdown(),
                                            (answer_instruction_model_dropdown) => {
                                              return $compose.children(
                                                $dropdown.dropdown(),
                                                (
                                                    agentic_loop_driver_model_dropdown
                                                  ) => {
                                                  return $redraw.component_(
                                                    "ChoiceOfModels",
                                                    (_use0) => {
                                                      let ai_config = _use0[0];
                                                      let set_ai_config = _use0[1];
                                                      if (
                                                        ai_config instanceof $remote.NotLoaded
                                                      ) {
                                                        return $skeleton.skeleton(
                                                          100,
                                                          100,
                                                        );
                                                      } else if (
                                                        ai_config instanceof $remote.Loading
                                                      ) {
                                                        return $skeleton.skeleton(
                                                          100,
                                                          100,
                                                        );
                                                      } else if (
                                                        ai_config instanceof $remote.Errored
                                                      ) {
                                                        return $skeleton.skeleton(
                                                          100,
                                                          100,
                                                        );
                                                      } else {
                                                        let ai_config$1 = ai_config[0];
                                                        return $l.column(
                                                          toList([$l.gap(12)]),
                                                          toList([]),
                                                          toList([
                                                            $common.underlined_title(
                                                              toList([]),
                                                              toList([
                                                                $h.text(
                                                                  "LLM Models",
                                                                ),
                                                              ]),
                                                            ),
                                                            $l.row(
                                                              toList([
                                                                $l.gap(12),
                                                                $l.wrap("wrap"),
                                                              ]),
                                                              toList([]),
                                                              toList([
                                                                $card.card(
                                                                  toList([]),
                                                                  toList([
                                                                    $card.title(
                                                                      toList([]),
                                                                      toList([
                                                                        $h.text(
                                                                          "Default Model",
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                    $card.body(
                                                                      toList([]),
                                                                      toList([
                                                                        model_selection_dropdown(
                                                                          ai_config$1,
                                                                          set_ai_config,
                                                                          default_model_dropdown,
                                                                          ai_config$1.config.models_config.default_model,
                                                                          $ai_config.set_default_model,
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                  ]),
                                                                ),
                                                                $card.card(
                                                                  toList([]),
                                                                  toList([
                                                                    $card.title(
                                                                      toList([]),
                                                                      toList([
                                                                        $h.text(
                                                                          "Rag Model",
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                    $card.body(
                                                                      toList([]),
                                                                      toList([
                                                                        model_selection_dropdown(
                                                                          ai_config$1,
                                                                          set_ai_config,
                                                                          rag_model_dropdown,
                                                                          ai_config$1.config.models_config.rag,
                                                                          $ai_config.set_rag_model,
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                  ]),
                                                                ),
                                                                $card.card(
                                                                  toList([]),
                                                                  toList([
                                                                    $card.title(
                                                                      toList([]),
                                                                      toList([
                                                                        $h.text(
                                                                          "Search Model",
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                    $card.body(
                                                                      toList([]),
                                                                      toList([
                                                                        model_selection_dropdown(
                                                                          ai_config$1,
                                                                          set_ai_config,
                                                                          search_model_dropdown,
                                                                          ai_config$1.config.models_config.search_model,
                                                                          $ai_config.set_search_model,
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                  ]),
                                                                ),
                                                                $card.card(
                                                                  toList([]),
                                                                  toList([
                                                                    $card.title(
                                                                      toList([]),
                                                                      toList([
                                                                        $h.text(
                                                                          "Agentic Loop Driver Model",
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                    $card.body(
                                                                      toList([]),
                                                                      toList([
                                                                        model_selection_dropdown(
                                                                          ai_config$1,
                                                                          set_ai_config,
                                                                          agentic_loop_driver_model_dropdown,
                                                                          ai_config$1.config.models_config.agentic_loop_driver_model,
                                                                          $ai_config.set_agentic_loop_driver_model,
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                  ]),
                                                                ),
                                                                $card.card(
                                                                  toList([]),
                                                                  toList([
                                                                    $card.title(
                                                                      toList([]),
                                                                      toList([
                                                                        $h.text(
                                                                          "Translate Model",
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                    $card.body(
                                                                      toList([]),
                                                                      toList([
                                                                        model_selection_dropdown(
                                                                          ai_config$1,
                                                                          set_ai_config,
                                                                          translate_model_dropdown,
                                                                          ai_config$1.config.models_config.translate_model,
                                                                          $ai_config.set_translate_model,
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                  ]),
                                                                ),
                                                                $card.card(
                                                                  toList([]),
                                                                  toList([
                                                                    $card.title(
                                                                      toList([]),
                                                                      toList([
                                                                        $h.text(
                                                                          "Conversational Model",
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                    $card.body(
                                                                      toList([]),
                                                                      toList([
                                                                        model_selection_dropdown(
                                                                          ai_config$1,
                                                                          set_ai_config,
                                                                          conversational_model_dropdown,
                                                                          ai_config$1.config.models_config.conversational_model,
                                                                          $ai_config.set_conversational_model,
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                  ]),
                                                                ),
                                                                $card.card(
                                                                  toList([]),
                                                                  toList([
                                                                    $card.title(
                                                                      toList([]),
                                                                      toList([
                                                                        $h.text(
                                                                          "Website Scrapping Model",
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                    $card.body(
                                                                      toList([]),
                                                                      toList([
                                                                        model_selection_dropdown(
                                                                          ai_config$1,
                                                                          set_ai_config,
                                                                          website_scrapping_model_dropdown,
                                                                          ai_config$1.config.models_config.website_scrapping_model,
                                                                          $ai_config.set_website_scrapping_model,
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                  ]),
                                                                ),
                                                                $card.card(
                                                                  toList([]),
                                                                  toList([
                                                                    $card.title(
                                                                      toList([]),
                                                                      toList([
                                                                        $h.text(
                                                                          "Rows/Columns Detection Model",
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                    $card.body(
                                                                      toList([]),
                                                                      toList([
                                                                        model_selection_dropdown(
                                                                          ai_config$1,
                                                                          set_ai_config,
                                                                          rows_columns_model_dropdown,
                                                                          ai_config$1.config.models_config.rows_columns_detection_model,
                                                                          $ai_config.set_rows_columns_detection_model,
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                  ]),
                                                                ),
                                                                $card.card(
                                                                  toList([]),
                                                                  toList([
                                                                    $card.title(
                                                                      toList([]),
                                                                      toList([
                                                                        $h.text(
                                                                          "Advanced Cell Detection Model",
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                    $card.body(
                                                                      toList([]),
                                                                      toList([
                                                                        model_selection_dropdown(
                                                                          ai_config$1,
                                                                          set_ai_config,
                                                                          advanced_cell_model_dropdown,
                                                                          ai_config$1.config.models_config.advanced_cell_detection_model,
                                                                          $ai_config.set_advanced_cell_detection_model,
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                  ]),
                                                                ),
                                                                $card.card(
                                                                  toList([]),
                                                                  toList([
                                                                    $card.title(
                                                                      toList([]),
                                                                      toList([
                                                                        $h.text(
                                                                          "Docx Question Detection Model",
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                    $card.body(
                                                                      toList([]),
                                                                      toList([
                                                                        model_selection_dropdown(
                                                                          ai_config$1,
                                                                          set_ai_config,
                                                                          docx_question_model_dropdown,
                                                                          ai_config$1.config.models_config.docx_question_detection_model,
                                                                          $ai_config.set_docx_question_detection_model,
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                  ]),
                                                                ),
                                                                $card.card(
                                                                  toList([]),
                                                                  toList([
                                                                    $card.title(
                                                                      toList([]),
                                                                      toList([
                                                                        $h.text(
                                                                          "Website Capture Model",
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                    $card.body(
                                                                      toList([]),
                                                                      toList([
                                                                        model_selection_dropdown(
                                                                          ai_config$1,
                                                                          set_ai_config,
                                                                          website_capture_model_dropdown,
                                                                          ai_config$1.config.models_config.website_capture_model,
                                                                          $ai_config.set_website_capture_model,
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                  ]),
                                                                ),
                                                                $card.card(
                                                                  toList([]),
                                                                  toList([
                                                                    $card.title(
                                                                      toList([]),
                                                                      toList([
                                                                        $h.text(
                                                                          "Answer Instruction Model",
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                    $card.body(
                                                                      toList([]),
                                                                      toList([
                                                                        model_selection_dropdown(
                                                                          ai_config$1,
                                                                          set_ai_config,
                                                                          answer_instruction_model_dropdown,
                                                                          ai_config$1.config.models_config.answer_instruction_model,
                                                                          $ai_config.set_answer_instruction_model,
                                                                        ),
                                                                      ]),
                                                                    ),
                                                                  ]),
                                                                ),
                                                              ]),
                                                            ),
                                                          ]),
                                                        );
                                                      }
                                                    },
                                                  );
                                                },
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function optional_previous_variant(ai_config, set_ai_config, variant_dropdown) {
  let _block;
  let _pipe = toList([$dropdown.choice("None", new None())]);
  _block = $list.append(
    _pipe,
    $list.map(
      $weaviate.all_variants,
      (s) => {
        if (s instanceof $weaviate.Base) {
          return $dropdown.choice("Base", new Some(s));
        } else {
          return $dropdown.choice($weaviate.variant_to_string(s), new Some(s));
        }
      },
    ),
  );
  let variant_choices = _block;
  return $l.column(
    toList([]),
    toList([]),
    toList([
      $typography.text(
        $typography.sm,
        $typography.medium,
        "Previous Write variant",
      ),
      (() => {
        let _pipe$1 = $dropdown.on_selected(
          (v) => {
            let _pipe$1 = ai_config;
            let _pipe$2 = $ai_config.set_prev_write_collection_variant(
              _pipe$1,
              $option.flatten(v),
            );
            let _pipe$3 = new $remote.Loaded(_pipe$2);
            return set_ai_config(_pipe$3);
          },
        );
        let _pipe$2 = $dropdown.placeholder(
          _pipe$1,
          "Select previous write collection...",
        );
        let _pipe$3 = $dropdown.selected(
          _pipe$2,
          new Some(ai_config.config.prev_write_collection_variant),
        );
        let _pipe$4 = $dropdown.show_arrow(_pipe$3, true);
        return variant_dropdown(_pipe$4, variant_choices);
      })(),
    ]),
  );
}

function read_write_variants(ai_config, set_ai_config, variant_dropdown) {
  return $l.row(
    toList([$l.gap(8)]),
    toList([]),
    toList([
      $l.column(
        toList([]),
        toList([]),
        toList([
          $typography.text($typography.sm, $typography.medium, "Read variant"),
          (() => {
            let _pipe = $dropdown.on_selected_(
              (v) => {
                let _pipe = ai_config;
                let _pipe$1 = $ai_config.set_read_collection_variant(_pipe, v);
                let _pipe$2 = new $remote.Loaded(_pipe$1);
                return set_ai_config(_pipe$2);
              },
            );
            let _pipe$1 = $dropdown.placeholder(
              _pipe,
              "Select read collection...",
            );
            let _pipe$2 = $dropdown.selected(
              _pipe$1,
              new Some(ai_config.config.read_collection_variant),
            );
            let _pipe$3 = $dropdown.show_arrow(_pipe$2, true);
            return variant_dropdown(_pipe$3, $org_common.variant_choices());
          })(),
        ]),
      ),
      $l.column(
        toList([]),
        toList([]),
        toList([
          $typography.text($typography.sm, $typography.medium, "Write variant"),
          (() => {
            let _pipe = $dropdown.on_selected_(
              (v) => {
                let _pipe = ai_config;
                let _pipe$1 = $ai_config.set_write_collection_variant(_pipe, v);
                let _pipe$2 = new $remote.Loaded(_pipe$1);
                return set_ai_config(_pipe$2);
              },
            );
            let _pipe$1 = $dropdown.placeholder(
              _pipe,
              "Select write collection...",
            );
            let _pipe$2 = $dropdown.selected(
              _pipe$1,
              new Some(ai_config.config.write_collection_variant),
            );
            let _pipe$3 = $dropdown.show_arrow(_pipe$2, true);
            return variant_dropdown(_pipe$3, $org_common.variant_choices());
          })(),
        ]),
      ),
    ]),
  );
}

function context_window_inputs(ai_config, set_ai_config) {
  let context_window = ai_config.config.context_window;
  let is_enabled = context_window.lookback > 0;
  let set_ai_config$1 = (s) => { return set_ai_config(new $remote.Loaded(s)); };
  if (is_enabled) {
    return $l.column(
      toList([$l.gap(6)]),
      toList([]),
      toList([
        $l.column(
          toList([$l.gap(3)]),
          toList([]),
          toList([
            $h.text("Lookback (number of previous questions)"),
            $input.input(
              (() => {
                let _pipe = $input.value(
                  $int.to_string(context_window.lookback),
                );
                let _pipe$1 = $input.type_(_pipe, "number");
                let _pipe$2 = $input.step(_pipe$1, "1");
                let _pipe$3 = $input.min(_pipe$2, "1");
                return $input.on_input(
                  _pipe$3,
                  (lookback) => {
                    let _pipe$4 = ai_config;
                    let _pipe$5 = $ai_config.set_context_window(
                      _pipe$4,
                      lookback,
                      $int.to_string(context_window.lookahead),
                    );
                    return set_ai_config$1(_pipe$5);
                  },
                );
              })(),
            ),
          ]),
        ),
        $l.column(
          toList([$l.gap(3)]),
          toList([]),
          toList([
            $h.text("Lookahead (reserved for future use, keep at 0)"),
            $input.input(
              (() => {
                let _pipe = $input.value(
                  $int.to_string(context_window.lookahead),
                );
                let _pipe$1 = $input.type_(_pipe, "number");
                let _pipe$2 = $input.step(_pipe$1, "1");
                let _pipe$3 = $input.min(_pipe$2, "0");
                let _pipe$4 = $input.disabled(_pipe$3, true);
                return $input.on_input(
                  _pipe$4,
                  (lookahead) => {
                    let _pipe$5 = ai_config;
                    let _pipe$6 = $ai_config.set_context_window(
                      _pipe$5,
                      $int.to_string(context_window.lookback),
                      lookahead,
                    );
                    return set_ai_config$1(_pipe$6);
                  },
                );
              })(),
            ),
          ]),
        ),
      ]),
    );
  } else {
    return $h.text("Context window is disabled. Toggle on to enable.");
  }
}

function context_window_toggle(ai_config, set_ai_config) {
  let context_window = ai_config.config.context_window;
  let is_enabled = context_window.lookback > 0;
  return $toggler.toggler(
    toList([
      $toggler.active(is_enabled),
      $toggler.on_change(
        (_) => {
          let lookahead = $int.to_string(context_window.lookahead);
          let _block;
          if (is_enabled) {
            _block = $ai_config.default_deactivated_context_window_lookback;
          } else {
            _block = $ai_config.default_activated_context_window_lookback;
          }
          let _pipe = _block;
          let _pipe$1 = $int.to_string(_pipe);
          let _pipe$2 = ((_capture) => {
            return $ai_config.set_context_window(ai_config, _capture, lookahead);
          })(_pipe$1);
          let _pipe$3 = new $remote.Loaded(_pipe$2);
          return set_ai_config(_pipe$3);
        },
      ),
    ]),
  );
}

function agentic_retrieval_inputs(ai_config, set_ai_config) {
  let $ = ai_config.config.query_config.agentic_retrieval;
  if ($ instanceof Some) {
    let agentic_retrieval = $[0];
    let set_ai_config$1 = (s) => { return set_ai_config(new $remote.Loaded(s)); };
    return $l.column(
      toList([$l.gap(6)]),
      toList([]),
      toList([
        $l.column(
          toList([$l.gap(3)]),
          toList([]),
          toList([
            $h.text("Max documents"),
            $input.input(
              (() => {
                let _pipe = $input.value(
                  $int.to_string(agentic_retrieval.max_docs),
                );
                let _pipe$1 = $input.type_(_pipe, "number");
                let _pipe$2 = $input.step(_pipe$1, "1");
                return $input.on_input(
                  _pipe$2,
                  (i) => {
                    let _pipe$3 = ai_config;
                    let _pipe$4 = $ai_config.set_agentic_retrieval_max_docs(
                      _pipe$3,
                      i,
                    );
                    return set_ai_config$1(_pipe$4);
                  },
                );
              })(),
            ),
          ]),
        ),
        $l.column(
          toList([$l.gap(3)]),
          toList([]),
          toList([
            $h.text("Max iterations"),
            $input.input(
              (() => {
                let _pipe = $input.value(
                  $int.to_string(agentic_retrieval.max_iterations),
                );
                let _pipe$1 = $input.type_(_pipe, "number");
                let _pipe$2 = $input.step(_pipe$1, "1");
                return $input.on_input(
                  _pipe$2,
                  (i) => {
                    let _pipe$3 = ai_config;
                    let _pipe$4 = $ai_config.set_agentic_retrieval_max_iterations(
                      _pipe$3,
                      i,
                    );
                    return set_ai_config$1(_pipe$4);
                  },
                );
              })(),
            ),
          ]),
        ),
        $l.column(
          toList([$l.gap(3)]),
          toList([]),
          toList([
            $h.text("Max queries"),
            $input.input(
              (() => {
                let _pipe = $input.value(
                  (() => {
                    let _pipe = agentic_retrieval.max_queries;
                    return $int.to_string(_pipe);
                  })(),
                );
                let _pipe$1 = $input.type_(_pipe, "number");
                let _pipe$2 = $input.step(_pipe$1, "1");
                return $input.on_input(
                  _pipe$2,
                  (i) => {
                    let _pipe$3 = ai_config;
                    let _pipe$4 = $ai_config.set_agentic_retrieval_max_queries(
                      _pipe$3,
                      i,
                    );
                    return set_ai_config$1(_pipe$4);
                  },
                );
              })(),
            ),
          ]),
        ),
      ]),
    );
  } else {
    return $h.text("No agentic config found.");
  }
}

function agentic_retrieval_toggle(ai_config, set_ai_config) {
  let retrieval = ai_config.config.query_config.agentic_retrieval;
  return $toggler.toggler(
    toList([
      $toggler.active($option.is_some(retrieval)),
      $toggler.on_change(
        (_) => {
          let _pipe = ai_config;
          let _pipe$1 = $ai_config.toggle_agentic_retrieval_config(_pipe);
          let _pipe$2 = new $remote.Loaded(_pipe$1);
          return set_ai_config(_pipe$2);
        },
      ),
    ]),
  );
}

function alpha_input(ai_config, set_ai_config) {
  let alpha = ai_config.config.query_config.alpha;
  return $input.input(
    (() => {
      let _pipe = $input.value($float.to_string(alpha));
      let _pipe$1 = $input.type_(_pipe, "number");
      let _pipe$2 = $input.step(_pipe$1, "0.1");
      let _pipe$3 = $input.max(_pipe$2, "1");
      let _pipe$4 = $input.min(_pipe$3, "0");
      return $input.on_input(
        _pipe$4,
        (s) => {
          let _pipe$5 = ai_config;
          let _pipe$6 = $ai_config.set_query_alpha(_pipe$5, s);
          let _pipe$7 = new $remote.Loaded(_pipe$6);
          return set_ai_config(_pipe$7);
        },
      );
    })(),
  );
}

function query_limit_input(ai_config, set_ai_config) {
  let query_limit = ai_config.config.query_config.limit;
  return $input.input(
    (() => {
      let _pipe = $input.value($int.to_string(query_limit));
      let _pipe$1 = $input.type_(_pipe, "number");
      return $input.on_input(
        _pipe$1,
        (s) => {
          let _pipe$2 = ai_config;
          let _pipe$3 = $ai_config.set_query_limit(_pipe$2, s);
          let _pipe$4 = new $remote.Loaded(_pipe$3);
          return set_ai_config(_pipe$4);
        },
      );
    })(),
  );
}

function on_update_ai_config(config, setter, set_ai_config) {
  return $e.on_click(
    (_) => {
      let _pipe = config;
      let _pipe$1 = setter(_pipe);
      let _pipe$2 = new $remote.Loaded(_pipe$1);
      return set_ai_config(_pipe$2);
    },
  );
}

function retriever_option(config, retriever, set_ai_config) {
  let setter = (_capture) => {
    return $ai_config.set_retriever_option(_capture, retriever);
  };
  let on_click = on_update_ai_config(config, setter, set_ai_config);
  let attrs = toList([on_click, $button.attributes.small()]);
  let _block;
  if (retriever instanceof $ai_config.Hybrid) {
    _block = "Hybrid";
  } else if (retriever instanceof $ai_config.Rerank) {
    _block = "Rerank";
  } else {
    _block = "Fusion";
  }
  let title = _block;
  let content = toList([$h.text(title)]);
  let $ = isEqual(config.config.retriever_config.option, retriever);
  if ($) {
    return $button.primary(attrs, content);
  } else {
    return $button.secondary(attrs, content);
  }
}

function search_config() {
  return $compose.children(
    $dropdown.dropdown(),
    (read_write_variant_dropdown) => {
      return $compose.children(
        $dropdown.dropdown(),
        (optional_variant_dropdown) => {
          return $redraw.component_(
            "SearchConfig",
            (_use0) => {
              let ai_config = _use0[0];
              let set_ai_config = _use0[1];
              if (ai_config instanceof $remote.NotLoaded) {
                return $skeleton.skeleton(100, 100);
              } else if (ai_config instanceof $remote.Loading) {
                return $skeleton.skeleton(100, 100);
              } else if (ai_config instanceof $remote.Errored) {
                return $skeleton.skeleton(100, 100);
              } else {
                let ai_config$1 = ai_config[0];
                return $l.column(
                  toList([$l.gap(12)]),
                  toList([]),
                  toList([
                    $common.underlined_title(
                      toList([]),
                      toList([$h.text("Search")]),
                    ),
                    $l.row(
                      toList([$l.gap(12)]),
                      toList([]),
                      toList([
                        $card.card(
                          toList([]),
                          toList([
                            $card.title(
                              toList([]),
                              toList([$h.text("Retriever")]),
                            ),
                            $card.body(
                              toList([]),
                              toList([
                                $l.row(
                                  toList([$l.gap(6)]),
                                  toList([]),
                                  $list.map(
                                    $ai_config.retriever_options,
                                    (retriever) => {
                                      return retriever_option(
                                        ai_config$1,
                                        retriever,
                                        set_ai_config,
                                      );
                                    },
                                  ),
                                ),
                              ]),
                            ),
                          ]),
                        ),
                        $card.card(
                          toList([]),
                          toList([
                            $card.title(
                              toList([]),
                              toList([$h.text("Limit of queried nodes")]),
                            ),
                            $card.body(
                              toList([]),
                              toList([
                                query_limit_input(ai_config$1, set_ai_config),
                              ]),
                            ),
                          ]),
                        ),
                        $card.card(
                          toList([]),
                          toList([
                            $card.title(
                              toList([]),
                              toList([$h.text("Alpha value")]),
                            ),
                            $card.body(
                              toList([]),
                              toList([alpha_input(ai_config$1, set_ai_config)]),
                            ),
                          ]),
                        ),
                      ]),
                    ),
                    $card.card(
                      toList([]),
                      toList([
                        $card.title(
                          toList([]),
                          toList([
                            $l.row(
                              toList([$l.justify("space-between"), $l.gap(6)]),
                              toList([]),
                              toList([
                                $h.text("Agentic on/off"),
                                agentic_retrieval_toggle(
                                  ai_config$1,
                                  set_ai_config,
                                ),
                              ]),
                            ),
                          ]),
                        ),
                        $card.body(
                          toList([]),
                          toList([
                            agentic_retrieval_inputs(ai_config$1, set_ai_config),
                          ]),
                        ),
                      ]),
                    ),
                    $card.card(
                      toList([]),
                      toList([
                        $card.title(
                          toList([]),
                          toList([
                            $l.row(
                              toList([$l.justify("space-between"), $l.gap(6)]),
                              toList([]),
                              toList([
                                $h.text("Context Window on/off"),
                                context_window_toggle(
                                  ai_config$1,
                                  set_ai_config,
                                ),
                              ]),
                            ),
                          ]),
                        ),
                        $card.body(
                          toList([]),
                          toList([
                            context_window_inputs(ai_config$1, set_ai_config),
                          ]),
                        ),
                      ]),
                    ),
                    $card.card(
                      toList([]),
                      toList([
                        $card.title(
                          toList([]),
                          toList([$h.text("Collection variants")]),
                        ),
                        $card.body(
                          toList([]),
                          toList([
                            $l.row(
                              toList([$l.gap(8)]),
                              toList([]),
                              toList([
                                read_write_variants(
                                  ai_config$1,
                                  set_ai_config,
                                  read_write_variant_dropdown,
                                ),
                                optional_previous_variant(
                                  ai_config$1,
                                  set_ai_config,
                                  optional_variant_dropdown,
                                ),
                              ]),
                            ),
                          ]),
                        ),
                      ]),
                    ),
                  ]),
                );
              }
            },
          );
        },
      );
    },
  );
}

function verbosity_button(config, verbosity, set_ai_config) {
  let _block;
  if (verbosity instanceof Some) {
    let $ = verbosity[0];
    if ($ instanceof $ai_config.VerbosityLow) {
      _block = "Low";
    } else if ($ instanceof $ai_config.VerbosityMedium) {
      _block = "Medium";
    } else {
      _block = "High";
    }
  } else {
    _block = "None";
  }
  let title = _block;
  let setter = (_capture) => {
    return $ai_config.set_verbosity(_capture, verbosity);
  };
  let on_click = on_update_ai_config(config, setter, set_ai_config);
  let attrs = toList([on_click, $button.attributes.small()]);
  let content = toList([$h.text(title)]);
  let $ = isEqual(config.config.models_config.verbosity, verbosity);
  if ($) {
    return $button.primary(attrs, content);
  } else {
    return $button.secondary(attrs, content);
  }
}

function reasoning_effort_button(config, effort, set_ai_config) {
  let _block;
  if (effort instanceof Some) {
    let $ = effort[0];
    if ($ instanceof $ai_config.ReasoningLow) {
      _block = "Low";
    } else if ($ instanceof $ai_config.ReasoningMedium) {
      _block = "Medium";
    } else {
      _block = "High";
    }
  } else {
    _block = "None";
  }
  let title = _block;
  let setter = (_capture) => {
    return $ai_config.set_reasoning_effort(_capture, effort);
  };
  let on_click = on_update_ai_config(config, setter, set_ai_config);
  let attrs = toList([on_click, $button.attributes.small()]);
  let content = toList([$h.text(title)]);
  let $ = isEqual(config.config.models_config.reasoning_effort, effort);
  if ($) {
    return $button.primary(attrs, content);
  } else {
    return $button.secondary(attrs, content);
  }
}

function convert_markdown_to_html_toggle(ai_config, set_ai_config) {
  let convert_markdown_to_html = ai_config.config.models_config.convert_markdown_to_html;
  return $toggler.toggler(
    toList([
      $toggler.active(convert_markdown_to_html),
      $toggler.on_change(
        (_) => {
          let _pipe = ai_config;
          let _pipe$1 = $ai_config.set_convert_markdown_to_html(
            _pipe,
            !convert_markdown_to_html,
          );
          let _pipe$2 = new $remote.Loaded(_pipe$1);
          return set_ai_config(_pipe$2);
        },
      ),
    ]),
  );
}

function llm_judge_in_the_loop_toggle_card(ai_config, set_ai_config) {
  let llm_judge_in_the_loop = ai_config.config.llm_judge_in_the_loop;
  return $card.card(
    toList([]),
    toList([
      $card.title(toList([]), toList([$h.text("Use LLM Judge In The Loop")])),
      $card.body(
        toList([]),
        toList([
          $toggler.toggler(
            toList([
              $toggler.active(llm_judge_in_the_loop),
              $toggler.on_change(
                (_) => {
                  let _pipe = ai_config;
                  let _pipe$1 = $ai_config.set_llm_judge_in_the_loop(
                    _pipe,
                    !llm_judge_in_the_loop,
                  );
                  let _pipe$2 = new $remote.Loaded(_pipe$1);
                  return set_ai_config(_pipe$2);
                },
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}

function run_style_prompt_toggle(ai_config, set_ai_config) {
  let run_style_prompt = ai_config.config.models_config.run_style_prompt;
  return $toggler.toggler(
    toList([
      $toggler.active(run_style_prompt),
      $toggler.on_change(
        (_) => {
          let _pipe = ai_config;
          let _pipe$1 = $ai_config.set_run_style_prompt(
            _pipe,
            !run_style_prompt,
          );
          let _pipe$2 = new $remote.Loaded(_pipe$1);
          return set_ai_config(_pipe$2);
        },
      ),
    ]),
  );
}

function rag_structured_call_toggle(ai_config, set_ai_config) {
  let rag_structured_call = ai_config.config.models_config.rag_structured_call;
  return $toggler.toggler(
    toList([
      $toggler.active(rag_structured_call),
      $toggler.on_change(
        (_) => {
          let _pipe = ai_config;
          let _pipe$1 = $ai_config.set_rag_structured_call(
            _pipe,
            !rag_structured_call,
          );
          let _pipe$2 = new $remote.Loaded(_pipe$1);
          return set_ai_config(_pipe$2);
        },
      ),
    ]),
  );
}

function llm_limit_input(ai_config, set_ai_config) {
  let limit = ai_config.config.llm_config.limit;
  return $input.input(
    (() => {
      let _pipe = $input.value($int.to_string(limit));
      let _pipe$1 = $input.type_(_pipe, "number");
      return $input.on_input(
        _pipe$1,
        (s) => {
          let _pipe$2 = ai_config;
          let _pipe$3 = $ai_config.set_llm_limit(_pipe$2, s);
          let _pipe$4 = new $remote.Loaded(_pipe$3);
          return set_ai_config(_pipe$4);
        },
      );
    })(),
  );
}

function use_dates_toggle(ai_config, on_click) {
  let use_dates = ai_config.config.query_config.use_dates;
  let attrs = toList([$e.on_click((_) => { return on_click(); })]);
  let content = toList([$h.text("Use dates")]);
  if (use_dates) {
    return $button.primary(attrs, content);
  } else {
    return $button.secondary(attrs, content);
  }
}

function split_query_toggle(ai_config, on_click) {
  let split_query = ai_config.config.query_config.split_query;
  let attrs = toList([$e.on_click((_) => { return on_click(); })]);
  let content = toList([$h.text("Split query")]);
  if (split_query) {
    return $button.primary(attrs, content);
  } else {
    return $button.secondary(attrs, content);
  }
}

function minimal_score_input(ai_config, set_ai_config) {
  let minimal_score = ai_config.config.query_config.minimal_score;
  return $input.input(
    (() => {
      let _pipe = $input.value($float.to_string(minimal_score));
      let _pipe$1 = $input.type_(_pipe, "number");
      let _pipe$2 = $input.step(_pipe$1, "0.1");
      let _pipe$3 = $input.min(_pipe$2, "0.0");
      let _pipe$4 = $input.max(_pipe$3, "1.0");
      return $input.on_input(
        _pipe$4,
        (s) => {
          let _pipe$5 = $ai_config.set_minimal_score(ai_config, s);
          let _pipe$6 = new $remote.Loaded(_pipe$5);
          return set_ai_config(_pipe$6);
        },
      );
    })(),
  );
}

function rag_modular_config_inputs(ai_config, set_ai_config) {
  let $ = ai_config.config.models_config.rag_modular_config;
  if ($ instanceof Some) {
    let modular = $[0];
    return $l.column(
      toList([$l.gap(12)]),
      toList([]),
      toList([
        $l.row(
          toList([$l.gap(12), $l.wrap("wrap")]),
          toList([]),
          toList([
            $card.card(
              toList([]),
              toList([
                $card.title(toList([]), toList([$h.text("Role ")])),
                $card.body(
                  toList([]),
                  toList([
                    $l.row(
                      toList([$l.gap(6), $l.wrap("wrap")]),
                      toList([]),
                      $list.map(
                        $ai_config.role_options,
                        (opt) => {
                          let _block;
                          if (opt instanceof $ai_config.RoleOff) {
                            _block = "Off";
                          } else {
                            _block = "RFP expert";
                          }
                          let title = _block;
                          let on_click = $e.on_click(
                            (_) => {
                              let _pipe = ai_config;
                              let _pipe$1 = $ai_config.set_rag_modular_role(
                                _pipe,
                                opt,
                              );
                              let _pipe$2 = new $remote.Loaded(_pipe$1);
                              return set_ai_config(_pipe$2);
                            },
                          );
                          let attrs = toList([
                            on_click,
                            $button.attributes.small(),
                          ]);
                          let $1 = isEqual(modular.role, opt);
                          if ($1) {
                            return $button.primary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          } else {
                            return $button.secondary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          }
                        },
                      ),
                    ),
                  ]),
                ),
              ]),
            ),
            $card.card(
              toList([]),
              toList([
                $card.title(toList([]), toList([$h.text("Entity Mismatch")])),
                $card.body(
                  toList([]),
                  toList([
                    $l.row(
                      toList([$l.gap(6), $l.wrap("wrap")]),
                      toList([]),
                      $list.map(
                        $ai_config.entity_mismatch_options,
                        (opt) => {
                          let _block;
                          if (opt instanceof $ai_config.EntityMismatchOff) {
                            _block = "Off";
                          } else {
                            _block = "Default";
                          }
                          let title = _block;
                          let on_click = $e.on_click(
                            (_) => {
                              let _pipe = ai_config;
                              let _pipe$1 = $ai_config.set_rag_modular_entity_mismatch(
                                _pipe,
                                opt,
                              );
                              let _pipe$2 = new $remote.Loaded(_pipe$1);
                              return set_ai_config(_pipe$2);
                            },
                          );
                          let attrs = toList([
                            on_click,
                            $button.attributes.small(),
                          ]);
                          let $1 = isEqual(modular.entity_mismatch, opt);
                          if ($1) {
                            return $button.primary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          } else {
                            return $button.secondary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          }
                        },
                      ),
                    ),
                  ]),
                ),
              ]),
            ),
            $card.card(
              toList([]),
              toList([
                $card.title(toList([]), toList([$h.text("Approach")])),
                $card.body(
                  toList([]),
                  toList([
                    $l.row(
                      toList([$l.gap(6), $l.wrap("wrap")]),
                      toList([]),
                      $list.map(
                        $ai_config.approach_options,
                        (opt) => {
                          let _block;
                          if (opt instanceof $ai_config.ApproachOff) {
                            _block = "Off";
                          } else {
                            _block = "Default";
                          }
                          let title = _block;
                          let on_click = $e.on_click(
                            (_) => {
                              let _pipe = ai_config;
                              let _pipe$1 = $ai_config.set_rag_modular_approach(
                                _pipe,
                                opt,
                              );
                              let _pipe$2 = new $remote.Loaded(_pipe$1);
                              return set_ai_config(_pipe$2);
                            },
                          );
                          let attrs = toList([
                            on_click,
                            $button.attributes.small(),
                          ]);
                          let $1 = isEqual(modular.approach, opt);
                          if ($1) {
                            return $button.primary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          } else {
                            return $button.secondary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          }
                        },
                      ),
                    ),
                  ]),
                ),
              ]),
            ),
            $card.card(
              toList([]),
              toList([
                $card.title(toList([]), toList([$h.text("Tone Style")])),
                $card.body(
                  toList([]),
                  toList([
                    $l.row(
                      toList([$l.gap(6), $l.wrap("wrap")]),
                      toList([]),
                      $list.map(
                        $ai_config.tone_style_options,
                        (opt) => {
                          let _block;
                          if (opt instanceof $ai_config.ToneStyleOff) {
                            _block = "Off";
                          } else {
                            _block = "Default";
                          }
                          let title = _block;
                          let on_click = $e.on_click(
                            (_) => {
                              let _pipe = ai_config;
                              let _pipe$1 = $ai_config.set_rag_modular_tone_style(
                                _pipe,
                                opt,
                              );
                              let _pipe$2 = new $remote.Loaded(_pipe$1);
                              return set_ai_config(_pipe$2);
                            },
                          );
                          let attrs = toList([
                            on_click,
                            $button.attributes.small(),
                          ]);
                          let $1 = isEqual(modular.tone_style, opt);
                          if ($1) {
                            return $button.primary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          } else {
                            return $button.secondary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          }
                        },
                      ),
                    ),
                  ]),
                ),
              ]),
            ),
            $card.card(
              toList([]),
              toList([
                $card.title(toList([]), toList([$h.text("Formatting")])),
                $card.body(
                  toList([]),
                  toList([
                    $l.row(
                      toList([$l.gap(6), $l.wrap("wrap")]),
                      toList([]),
                      $list.map(
                        $ai_config.formatting_options,
                        (opt) => {
                          let _block;
                          if (opt instanceof $ai_config.FormattingOff) {
                            _block = "Off";
                          } else {
                            _block = "Default";
                          }
                          let title = _block;
                          let on_click = $e.on_click(
                            (_) => {
                              let _pipe = ai_config;
                              let _pipe$1 = $ai_config.set_rag_modular_formatting(
                                _pipe,
                                opt,
                              );
                              let _pipe$2 = new $remote.Loaded(_pipe$1);
                              return set_ai_config(_pipe$2);
                            },
                          );
                          let attrs = toList([
                            on_click,
                            $button.attributes.small(),
                          ]);
                          let $1 = isEqual(modular.formatting, opt);
                          if ($1) {
                            return $button.primary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          } else {
                            return $button.secondary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          }
                        },
                      ),
                    ),
                  ]),
                ),
              ]),
            ),
            $card.card(
              toList([]),
              toList([
                $card.title(
                  toList([]),
                  toList([$h.text("Evidence Over Assertion")]),
                ),
                $card.body(
                  toList([]),
                  toList([
                    $l.row(
                      toList([$l.gap(6), $l.wrap("wrap")]),
                      toList([]),
                      $list.map(
                        $ai_config.evidence_over_assertion_options,
                        (opt) => {
                          let _block;
                          if (opt instanceof $ai_config.EvidenceOverAssertionOff) {
                            _block = "Off";
                          } else {
                            _block = "Default";
                          }
                          let title = _block;
                          let on_click = $e.on_click(
                            (_) => {
                              let _pipe = ai_config;
                              let _pipe$1 = $ai_config.set_rag_modular_evidence_over_assertion(
                                _pipe,
                                opt,
                              );
                              let _pipe$2 = new $remote.Loaded(_pipe$1);
                              return set_ai_config(_pipe$2);
                            },
                          );
                          let attrs = toList([
                            on_click,
                            $button.attributes.small(),
                          ]);
                          let $1 = isEqual(modular.evidence_over_assertion, opt);
                          if ($1) {
                            return $button.primary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          } else {
                            return $button.secondary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          }
                        },
                      ),
                    ),
                  ]),
                ),
              ]),
            ),
            $card.card(
              toList([]),
              toList([
                $card.title(toList([]), toList([$h.text("Redirect")])),
                $card.body(
                  toList([]),
                  toList([
                    $l.row(
                      toList([$l.gap(6), $l.wrap("wrap")]),
                      toList([]),
                      $list.map(
                        $ai_config.redirect_options,
                        (opt) => {
                          let _block;
                          if (opt instanceof $ai_config.RedirectOff) {
                            _block = "Off";
                          } else {
                            _block = "Default";
                          }
                          let title = _block;
                          let on_click = $e.on_click(
                            (_) => {
                              let _pipe = ai_config;
                              let _pipe$1 = $ai_config.set_rag_modular_redirect(
                                _pipe,
                                opt,
                              );
                              let _pipe$2 = new $remote.Loaded(_pipe$1);
                              return set_ai_config(_pipe$2);
                            },
                          );
                          let attrs = toList([
                            on_click,
                            $button.attributes.small(),
                          ]);
                          let $1 = isEqual(modular.redirect, opt);
                          if ($1) {
                            return $button.primary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          } else {
                            return $button.secondary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          }
                        },
                      ),
                    ),
                  ]),
                ),
              ]),
            ),
          ]),
        ),
        $l.row(
          toList([$l.gap(12), $l.wrap("wrap")]),
          toList([]),
          toList([
            $card.card(
              toList([]),
              toList([
                $card.title(toList([]), toList([$h.text("Tone Voice")])),
                $card.body(
                  toList([]),
                  toList([
                    $l.row(
                      toList([$l.gap(6), $l.wrap("wrap")]),
                      toList([]),
                      $list.map(
                        $ai_config.tone_voice_options,
                        (voice) => {
                          let _block;
                          if (voice instanceof $ai_config.ToneVoiceOff) {
                            _block = "Off";
                          } else if (
                            voice instanceof $ai_config.ToneVoiceCustomer
                          ) {
                            _block = "Customer";
                          } else if (
                            voice instanceof $ai_config.ToneVoiceEngaged
                          ) {
                            _block = "Engaged";
                          } else {
                            _block = "Generic";
                          }
                          let title = _block;
                          let on_click = $e.on_click(
                            (_) => {
                              let _pipe = ai_config;
                              let _pipe$1 = $ai_config.set_rag_modular_tone_voice(
                                _pipe,
                                voice,
                              );
                              let _pipe$2 = new $remote.Loaded(_pipe$1);
                              return set_ai_config(_pipe$2);
                            },
                          );
                          let attrs = toList([
                            on_click,
                            $button.attributes.small(),
                          ]);
                          let $1 = isEqual(modular.tone_voice, voice);
                          if ($1) {
                            return $button.primary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          } else {
                            return $button.secondary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          }
                        },
                      ),
                    ),
                  ]),
                ),
              ]),
            ),
            $card.card(
              toList([]),
              toList([
                $card.title(toList([]), toList([$h.text("Repeat Question")])),
                $card.body(
                  toList([]),
                  toList([
                    $l.row(
                      toList([$l.gap(6), $l.wrap("wrap")]),
                      toList([]),
                      $list.map(
                        $ai_config.repeat_question_options,
                        (repeat) => {
                          let _block;
                          if (repeat instanceof $ai_config.RepeatQuestionOff) {
                            _block = "Off";
                          } else if (repeat instanceof $ai_config.Repeat) {
                            _block = "Repeat";
                          } else if (repeat instanceof $ai_config.DoNotRepeat) {
                            _block = "Do Not Repeat";
                          } else {
                            _block = "Do Not Repeat (Warm)";
                          }
                          let title = _block;
                          let on_click = $e.on_click(
                            (_) => {
                              let _pipe = ai_config;
                              let _pipe$1 = $ai_config.set_rag_modular_repeat_question(
                                _pipe,
                                repeat,
                              );
                              let _pipe$2 = new $remote.Loaded(_pipe$1);
                              return set_ai_config(_pipe$2);
                            },
                          );
                          let attrs = toList([
                            on_click,
                            $button.attributes.small(),
                          ]);
                          let $1 = isEqual(
                            modular.repeat_or_not_question,
                            repeat
                          );
                          if ($1) {
                            return $button.primary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          } else {
                            return $button.secondary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          }
                        },
                      ),
                    ),
                  ]),
                ),
              ]),
            ),
            $card.card(
              toList([]),
              toList([
                $card.title(toList([]), toList([$h.text("Length")])),
                $card.body(
                  toList([]),
                  toList([
                    $l.row(
                      toList([$l.gap(6), $l.wrap("wrap")]),
                      toList([]),
                      $list.map(
                        $ai_config.length_rule_options,
                        (length) => {
                          let _block;
                          if (length instanceof $ai_config.LengthRuleOff) {
                            _block = "Off";
                          } else if (length instanceof $ai_config.CategoryBased) {
                            _block = "Category Based";
                          } else {
                            _block = "Generalistic";
                          }
                          let title = _block;
                          let on_click = $e.on_click(
                            (_) => {
                              let _pipe = ai_config;
                              let _pipe$1 = $ai_config.set_rag_modular_length(
                                _pipe,
                                length,
                              );
                              let _pipe$2 = new $remote.Loaded(_pipe$1);
                              return set_ai_config(_pipe$2);
                            },
                          );
                          let attrs = toList([
                            on_click,
                            $button.attributes.small(),
                          ]);
                          let $1 = isEqual(modular.length, length);
                          if ($1) {
                            return $button.primary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          } else {
                            return $button.secondary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          }
                        },
                      ),
                    ),
                  ]),
                ),
              ]),
            ),
            $card.card(
              toList([]),
              toList([
                $card.title(toList([]), toList([$h.text("What to Return")])),
                $card.body(
                  toList([]),
                  toList([
                    $l.row(
                      toList([$l.gap(6), $l.wrap("wrap")]),
                      toList([]),
                      $list.map(
                        $ai_config.what_to_return_options,
                        (what) => {
                          let _block;
                          if (what instanceof $ai_config.WhatToReturnOff) {
                            _block = "Off";
                          } else if (what instanceof $ai_config.ReturnJson) {
                            _block = "JSON";
                          } else {
                            _block = "Text";
                          }
                          let title = _block;
                          let on_click = $e.on_click(
                            (_) => {
                              let _pipe = ai_config;
                              let _pipe$1 = $ai_config.set_rag_modular_what_to_return(
                                _pipe,
                                what,
                              );
                              let _pipe$2 = new $remote.Loaded(_pipe$1);
                              return set_ai_config(_pipe$2);
                            },
                          );
                          let attrs = toList([
                            on_click,
                            $button.attributes.small(),
                          ]);
                          let $1 = isEqual(modular.what_to_return, what);
                          if ($1) {
                            return $button.primary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          } else {
                            return $button.secondary(
                              attrs,
                              toList([$h.text(title)]),
                            );
                          }
                        },
                      ),
                    ),
                  ]),
                ),
              ]),
            ),
          ]),
        ),
      ]),
    );
  } else {
    return $h.text("Modular prompt config is disabled. Toggle on to enable.");
  }
}

function rag_modular_config_toggle(ai_config, set_ai_config) {
  let modular = ai_config.config.models_config.rag_modular_config;
  return $toggler.toggler(
    toList([
      $toggler.active($option.is_some(modular)),
      $toggler.on_change(
        (_) => {
          let _pipe = ai_config;
          let _pipe$1 = $ai_config.toggle_rag_modular_config(_pipe);
          let _pipe$2 = new $remote.Loaded(_pipe$1);
          return set_ai_config(_pipe$2);
        },
      ),
    ]),
  );
}

function score_prompt_button(config, prompt, set_ai_config) {
  let setter = (_capture) => {
    return $ai_config.set_score_prompt(_capture, prompt);
  };
  let on_click = on_update_ai_config(config, setter, set_ai_config);
  let attrs = toList([on_click, $button.attributes.small()]);
  let _block;
  if (prompt instanceof $ai_config.ComputeScoreV1) {
    _block = "Compute Score V1";
  } else {
    _block = "Compute Score V2";
  }
  let title = _block;
  let content = toList([$h.text(title)]);
  let $ = isEqual(config.config.models_config.compute_score_prompt, prompt);
  if ($) {
    return $button.primary(attrs, content);
  } else {
    return $button.secondary(attrs, content);
  }
}

function ai_rag_button(config, prompt, set_ai_config) {
  let setter = (_capture) => {
    return $ai_config.set_rag_prompt(_capture, prompt);
  };
  let on_click = on_update_ai_config(config, setter, set_ai_config);
  let attrs = toList([on_click, $button.attributes.small()]);
  let _block;
  if (prompt instanceof $ai_config.QuestionAnswerV1) {
    _block = "Question Answer V1";
  } else if (prompt instanceof $ai_config.QuestionAnswerV2) {
    _block = "Question Answer V2";
  } else if (prompt instanceof $ai_config.AssessRequirementV1) {
    _block = "Assess Requirement V1";
  } else if (prompt instanceof $ai_config.AssessRequirementV2) {
    _block = "Assess Requirement V2";
  } else {
    _block = "Modular";
  }
  let title = _block;
  let content = toList([$h.text(title)]);
  let $ = isEqual(config.config.models_config.rag_prompt, prompt);
  if ($) {
    return $button.primary(attrs, content);
  } else {
    return $button.secondary(attrs, content);
  }
}

function ai_system_button(config, system, set_ai_config) {
  let setter = (_capture) => {
    return $ai_config.set_ai_system(_capture, system);
  };
  let on_click = on_update_ai_config(config, setter, set_ai_config);
  let attrs = toList([on_click, $button.attributes.small()]);
  let _block;
  if (system instanceof $ai_config.NaiveRag) {
    _block = "Naive Rag";
  } else if (system instanceof $ai_config.AdvancedRag) {
    _block = "Advanced Rag";
  } else if (system instanceof $ai_config.AgenticRag) {
    _block = "Agentic Rag";
  } else {
    _block = "LLM-Enhanced Vector Search";
  }
  let title = _block;
  let content = toList([$h.text(title)]);
  let $ = isEqual(config.config.ai_system, system);
  if ($) {
    return $button.primary(attrs, content);
  } else {
    return $button.secondary(attrs, content);
  }
}

function ai_system_config() {
  return $redraw.component_(
    "AiSystemConfig",
    (_use0) => {
      let ai_config = _use0[0];
      let set_ai_config = _use0[1];
      if (ai_config instanceof $remote.NotLoaded) {
        return $skeleton.skeleton(100, 100);
      } else if (ai_config instanceof $remote.Loading) {
        return $skeleton.skeleton(100, 100);
      } else if (ai_config instanceof $remote.Errored) {
        let error = ai_config[0];
        return $h.div(toList([]), toList([$h.text(error)]));
      } else {
        let ai_config$1 = ai_config[0];
        return $l.column(
          toList([$l.gap(12)]),
          toList([]),
          toList([
            $common.underlined_title(toList([]), toList([$h.text("AI System")])),
            $card.card(
              toList([]),
              toList([
                $card.title(toList([]), toList([$h.text("AI Approach")])),
                $card.body(
                  toList([]),
                  toList([
                    $l.row(
                      toList([$l.gap(6), $l.wrap("wrap")]),
                      toList([]),
                      $list.map(
                        $ai_config.systems,
                        (system) => {
                          return ai_system_button(
                            ai_config$1,
                            system,
                            set_ai_config,
                          );
                        },
                      ),
                    ),
                  ]),
                ),
              ]),
            ),
            $l.row(
              toList([$l.gap(12), $l.wrap("wrap")]),
              toList([]),
              toList([
                $card.card(
                  toList([]),
                  toList([
                    $card.title(toList([]), toList([$h.text("Target")])),
                    $card.body(
                      toList([]),
                      toList([
                        $h.text(
                          "Used to toggle between standard answers (Auto-fill) ",
                        ),
                        $h.text("and more verbose answers (Verbose), "),
                        $h.text(
                          "the latter being more suited for 'narrative' RFPs.",
                        ),
                      ]),
                    ),
                    $card.body(
                      toList([]),
                      toList([
                        $l.row(
                          toList([$l.gap(6), $l.wrap("wrap")]),
                          toList([]),
                          $list.map(
                            $ai_config.rag_prompts,
                            (prompt) => {
                              return ai_rag_button(
                                ai_config$1,
                                prompt,
                                set_ai_config,
                              );
                            },
                          ),
                        ),
                      ]),
                    ),
                  ]),
                ),
                $card.card(
                  toList([]),
                  toList([
                    $card.title(
                      toList([]),
                      toList([$h.text("Compute Score Prompt")]),
                    ),
                    $card.body(
                      toList([]),
                      toList([
                        $h.text(
                          "This controls the scoring prompt used to evaluate ",
                        ),
                        $h.text("answer quality."),
                      ]),
                    ),
                    $card.body(
                      toList([]),
                      toList([
                        $l.row(
                          toList([$l.gap(6), $l.wrap("wrap")]),
                          toList([]),
                          $list.map(
                            $ai_config.score_prompts,
                            (prompt) => {
                              return score_prompt_button(
                                ai_config$1,
                                prompt,
                                set_ai_config,
                              );
                            },
                          ),
                        ),
                      ]),
                    ),
                  ]),
                ),
              ]),
            ),
            $card.card(
              toList([]),
              toList([
                $card.title(
                  toList([]),
                  toList([
                    $l.row(
                      toList([$l.justify("space-between"), $l.gap(6)]),
                      toList([]),
                      toList([
                        $h.text("Modular Prompt Config on/off"),
                        rag_modular_config_toggle(ai_config$1, set_ai_config),
                      ]),
                    ),
                  ]),
                ),
                $card.body(
                  toList([]),
                  toList([rag_modular_config_inputs(ai_config$1, set_ai_config)]),
                ),
              ]),
            ),
            $l.row(
              toList([$l.gap(12), $l.wrap("wrap")]),
              toList([]),
              toList([
                $card.card(
                  toList([]),
                  toList([
                    $card.title(toList([]), toList([$h.text("Minimum score")])),
                    $card.body(
                      toList([]),
                      toList([minimal_score_input(ai_config$1, set_ai_config)]),
                    ),
                  ]),
                ),
                $card.card(
                  toList([]),
                  toList([
                    $card.title(toList([]), toList([$h.text("Split query")])),
                    $card.body(
                      toList([]),
                      toList([
                        split_query_toggle(
                          ai_config$1,
                          () => {
                            let _pipe = ai_config$1;
                            let _pipe$1 = $ai_config.toggle_split_query(_pipe);
                            let _pipe$2 = new $remote.Loaded(_pipe$1);
                            return set_ai_config(_pipe$2);
                          },
                        ),
                      ]),
                    ),
                  ]),
                ),
                $card.card(
                  toList([]),
                  toList([
                    $card.title(toList([]), toList([$h.text("Use dates")])),
                    $card.body(
                      toList([]),
                      toList([
                        use_dates_toggle(
                          ai_config$1,
                          () => {
                            let _pipe = ai_config$1;
                            let _pipe$1 = $ai_config.toggle_use_dates(_pipe);
                            let _pipe$2 = new $remote.Loaded(_pipe$1);
                            return set_ai_config(_pipe$2);
                          },
                        ),
                      ]),
                    ),
                  ]),
                ),
                $card.card(
                  toList([]),
                  toList([
                    $card.title(
                      toList([]),
                      toList([$h.text("Limit of nodes given to the LLM")]),
                    ),
                    $card.body(
                      toList([]),
                      toList([llm_limit_input(ai_config$1, set_ai_config)]),
                    ),
                  ]),
                ),
              ]),
            ),
            $l.row(
              toList([$l.gap(12), $l.wrap("wrap")]),
              toList([]),
              toList([
                $card.card(
                  toList([]),
                  toList([
                    $card.title(
                      toList([]),
                      toList([$h.text("Structured Call")]),
                    ),
                    $card.body(
                      toList([]),
                      toList([
                        rag_structured_call_toggle(ai_config$1, set_ai_config),
                      ]),
                    ),
                  ]),
                ),
                $card.card(
                  toList([]),
                  toList([
                    $card.title(
                      toList([]),
                      toList([$h.text("Run Style Prompt")]),
                    ),
                    $card.body(
                      toList([]),
                      toList([
                        run_style_prompt_toggle(ai_config$1, set_ai_config),
                      ]),
                    ),
                  ]),
                ),
                llm_judge_in_the_loop_toggle_card(ai_config$1, set_ai_config),
                $card.card(
                  toList([]),
                  toList([
                    $card.title(
                      toList([]),
                      toList([$h.text("Convert md to html")]),
                    ),
                    $card.body(
                      toList([]),
                      toList([
                        convert_markdown_to_html_toggle(
                          ai_config$1,
                          set_ai_config,
                        ),
                      ]),
                    ),
                  ]),
                ),
                $card.card(
                  toList([]),
                  toList([
                    $card.title(
                      toList([]),
                      toList([$h.text("Reasoning Effort")]),
                    ),
                    $card.body(
                      toList([]),
                      toList([
                        $l.row(
                          toList([$l.gap(6), $l.wrap("wrap")]),
                          toList([]),
                          $list.map(
                            $ai_config.reasoning_effort_options,
                            (effort) => {
                              return reasoning_effort_button(
                                ai_config$1,
                                effort,
                                set_ai_config,
                              );
                            },
                          ),
                        ),
                      ]),
                    ),
                  ]),
                ),
                $card.card(
                  toList([]),
                  toList([
                    $card.title(toList([]), toList([$h.text("Verbosity")])),
                    $card.body(
                      toList([]),
                      toList([
                        $l.row(
                          toList([$l.gap(6), $l.wrap("wrap")]),
                          toList([]),
                          $list.map(
                            $ai_config.verbosity_options,
                            (verbosity) => {
                              return verbosity_button(
                                ai_config$1,
                                verbosity,
                                set_ai_config,
                              );
                            },
                          ),
                        ),
                      ]),
                    ),
                  ]),
                ),
              ]),
            ),
          ]),
        );
      }
    },
  );
}

export function view() {
  return $compose.compose(
    ai_system_config(),
    (ai_system_config) => {
      return $compose.compose(
        search_config(),
        (search_config) => {
          return $compose.compose(
            choice_of_models(),
            (choice_of_models) => {
              return $compose.compose(
                pii_vocabulary(),
                (pii_vocabulary) => {
                  return $redraw.component_(
                    "Config(View)",
                    (_) => {
                      let store = $store.use_state();
                      let dispatch = $store.use_effect_dispatch();
                      let store_config = $store.organization_ai_config(store);
                      let $ = use_store_config(store_config);
                      let ai_config = $[0];
                      let set_ai_config = $[1];
                      return $redraw.fragment(
                        toList([
                          ai_system_config([ai_config, set_ai_config]),
                          search_config([ai_config, set_ai_config]),
                          choice_of_models([ai_config, set_ai_config]),
                          pii_vocabulary([ai_config, set_ai_config]),
                          (() => {
                            if (ai_config instanceof $remote.NotLoaded) {
                              return $h.none();
                            } else if (ai_config instanceof $remote.Loading) {
                              return $h.none();
                            } else if (ai_config instanceof $remote.Errored) {
                              return $h.none();
                            } else {
                              let config = ai_config[0];
                              let disabled = $a.disabled(
                                isEqual(ai_config, store_config),
                              );
                              let on_click = $e.on_click(
                                (_) => {
                                  dispatch(
                                    $ai_config_effects.set_ai_config(config),
                                  );
                                  return undefined;
                                },
                              );
                              return $l.row(
                                toList([$l.justify("end")]),
                                toList([]),
                                toList([
                                  $button.primary(
                                    toList([disabled, on_click]),
                                    toList([$h.text("Save AI config")]),
                                  ),
                                ]),
                              );
                            }
                          })(),
                        ]),
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
